import { PickingRouteLocalStorage } from '../interfaces/Picking/Picking'

// export const save = (key, value) => {
//   localStorage.setItem(key, value)
// }

// export const get = (key: string) => {
//   return localStorage.getItem(key)
// }

// export const checkExist = (key) => {
//   return localStorage.getItem(key) !== null
// }

// export const clear = (key) => {
//   localStorage.removeItem(key)
// }

// export const clearAll = () => {
//   localStorage.clear()
// }

export const saveDataPickingRoute = (
  id: number | undefined,
  listPositionsNoStockIn: string[] | [],
  listSkippedProductsIn: number[] | [],
  name: string
) => {
  let pickingRouteData: PickingRouteLocalStorage = {
    pickingRouteId: 0,
    listPositionsNoStock: [],
    listSkippedProducts: []
  }

  pickingRouteData = {
    pickingRouteId: id,
    listPositionsNoStock: listPositionsNoStockIn,
    listSkippedProducts: listSkippedProductsIn
  }

  localStorage.setItem(name, JSON.stringify(pickingRouteData))
}
